import { useState } from "react";
import type { Faq } from "@/types/content";

interface FaqAccordionProps {
  items: Faq[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? items[0]?.id ?? null);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden divide-y divide-background-200">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenId(isOpen ? null : item.id)}
                className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 md:py-5 text-left hover:bg-background-100/70 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base text-foreground-900">{item.question}</span>
                <span
                  className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {isOpen ? (
              <div className="px-4 md:px-6 pb-5 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl">{item.answer}</p>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}